import axios from "axios";
import { utilityServicesPath} from "../../Constants";

export default class UtilityHelpService {
    static async getThemeHelpUser() {
        return axios.get(`${utilityServicesPath}/user/theme-help`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getHelpUser() {
        return axios.get(`${utilityServicesPath}/user/help`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async get() {
        return axios.get(`${utilityServicesPath}/admin/help`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async add(data) {
        return await axios.post(`${utilityServicesPath}/admin/help`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/help/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${utilityServicesPath}/admin/help/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async getTheme() {
        return axios.get(`${utilityServicesPath}/admin/theme-help`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addTheme(data) {
        return await axios.post(`${utilityServicesPath}/admin/theme-help`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateTheme(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/theme-help/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteTheme(id) {
        return await axios.delete(`${utilityServicesPath}/admin/theme-help/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}